import { z } from 'zod'

export const reorderAccountsSchema = z.object({
  ids: z.array(z.string().guid()).min(1),
})

export type ReorderAccountsDto = z.infer<typeof reorderAccountsSchema>
